<div class="modal-body">
   <div class="container-fluid">
      <tabset>
         <tab heading="Origin Address Information" class="bol-addresses-tabFontSize" id="originAddress">
            <div class="p-3">
               <div class="py-3">
                  <h6 class="p-3 bol-addresses-headerBackground text-dark">Origin Address</h6>
               </div>
               <div id="originInfo" class="px-3">
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="originLine1" class="noMarginLeft">
                           Line 1
                        </label>
                        <div id="originLine1">{{originData?.addressLine1}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="originLine2" class="noMarginLeft">
                           Line 2
                        </label>
                        <div id="originLine2">{{originData?.addressLine2}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="originCity" class="noMarginLeft">
                           City
                        </label>
                        <div id="originCity">{{originData?.city}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="originCountry" class="noMarginLeft">
                           Country
                        </label>
                        <div id="originCountry">
                           {{originData?.countryId == null ? '' : originData?.countryEntity.stateCountryName}}
                        </div>
                     </div>
                  </div>
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="shipperStateZipCode" class="noMarginLeft">
                           State/Zip
                        </label>
                        <div id="shipperStateZipCode">
                           {{originData?.stateId == null ? '' : originData?.stateEntity.stateCountryName}},{{originData?.zipCode}}
                        </div>
                     </div>
                     <div class="col-md-3">
                        <label for="originPrimaryPhone" class="noMarginLeft">
                           Phone
                        </label>
                        <div id="originPrimaryPhone">{{originData?.phone}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="originExtension" class="noMarginLeft">
                           Ext
                        </label>
                        <div id="originExtension">{{originData?.phoneExt}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="originAlertnatePhone" class="noMarginLeft">
                           Alternate Phone
                        </label>
                        <div id="originAlertnatePhone">{{originData?.alternatePhone}}</div>
                     </div>
                  </div>
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="originEmail" class="noMarginLeft">
                           Email
                        </label>
                        <div id="originEmail">{{originData?.emailAddress}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="originOtherInfo" class="noMarginLeft">
                           Other Contact Information
                        </label>
                        <div id="originOtherInfo">{{originData?.otherContactInfo}}</div>
                     </div>
                  </div>
               </div>
               <div class="py-3">
                  <h6 class="p-3 mb-2 bol-addresses-headerBackground text-dark">Shipper Address</h6>
               </div>
               <div id="shiperInfo2" class="px-3">
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="shipperLine1" class="noMarginLeft">
                           Line 1
                        </label>
                        <div id="shipperLine1">{{shipperData?.addressLine1}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="shipperLine2" class="noMarginLeft">
                           Line 2
                        </label>
                        <div id="shipperLine2">{{shipperData?.addressLine2}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="shipperCity" class="noMarginLeft">
                           City
                        </label>
                        <div id="shipperCity">{{shipperData?.city}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="shipperCountry" class="noMarginLeft">
                           Country
                        </label>
                        <div id="shipperCountry">
                           {{shipperData?.countryId == null ? '' : shipperData?.countryEntity.stateCountryName}}
                        </div>
                     </div>
                  </div>
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="shipperStateZipCode" class="noMarginLeft">
                           State/Zip
                        </label>
                        <div>
                           {{shipperData?.stateId == null ? '' : shipperData?.stateEntity.stateCountryName}},{{shipperData?.zipCode}}
                        </div>
                     </div>
                     <div class="col-md-3">
                        <label for="shipperPhone" class="noMarginLeft">
                           Phone
                        </label>
                        <div id="shipperPhone">{{shipperData?.phone}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="shipperExtn" class="noMarginLeft">
                           Ext
                        </label>
                        <div id="shipperExtn">{{shipperData?.phoneExt}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="shipperEmail" class="noMarginLeft">
                           Email
                        </label>
                        <div id="shipperEmail">{{shipperData?.emailAddress}}</div>
                     </div>
                  </div>
               </div>
               <div class="py-3">
                  <h6 class="p-3 mb-2 bol-addresses-headerBackground text-dark">Bill To Address</h6>
               </div>
               <div id="billInfo" class="px-3">
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="billingAddrLine1" class="noMarginLeft">
                           Line 1
                        </label>
                        <div id="billingAddrLine1">{{billToData?.addressLine1}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="billingAddrLine2" class="noMarginLeft">
                           Line 2
                        </label>
                        <div id="billingAddrLine2">{{billToData?.addressLine2}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="billingAddrCity" class="noMarginLeft">
                           City
                        </label>
                        <div id="billingAddrCity">{{billToData?.city}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="billingAddrCountry" class="noMarginLeft">
                           Country
                        </label>
                        <div id="billingAddrCountry">
                           {{billToData?.countryId == null ? '' : billToData?.countryEntity.stateCountryName}}
                        </div>
                     </div>
                  </div>
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="billingAddrStateZipCode" class="noMarginLeft">
                           State/Zip
                        </label>
                        <div id="billingAddrStateZipCode">
                           {{billToData?.stateId == null ? '' : billToData?.stateEntity.stateCountryName}},{{billToData?.zipCode}}
                        </div>
                     </div>
                     <div class="col-md-3">
                        <label for="billingAddrPhone" class="noMarginLeft">
                           Phone
                        </label>
                        <div id="billingAddrPhone">{{billToData?.phone}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="billingAddrExtn" class="noMarginLeft">
                           Ext
                        </label>
                        <div id="billingAddrExtn">{{billToData?.phoneExt}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="billingAddrEmail" class="noMarginLeft">
                           Email
                        </label>
                        <div id="billingAddrEmail">{{billToData?.emailAddress}}</div>
                     </div>
                  </div>
               </div>
            </div>
         </tab>
         <tab heading="Destination Address Information" class="tabFontSize" id="destinationAddress">
            <div class="p-3">
               <div class="py-3">
                  <h6 class="p-3 mb-2 bol-addresses-headerBackground text-dark">Destination Address</h6>
               </div>
               <div id="originInfo2" class="px-3">
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="originLine1" class="noMarginLeft">
                           Line 1
                        </label>
                        <div>{{destinationData?.addressLine1}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="originLine2" class="noMarginLeft">
                           Line 2
                        </label>
                        <div>{{destinationData?.addressLine2}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="destinationCityS" class="noMarginLeft">
                           City
                        </label>
                        <div id="destinationCityS">{{destinationData?.city}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="destinationCountry" class="noMarginLeft">
                           Country
                        </label>
                        <div id="destinationCountry">
                           {{destinationData?.countryId == null ? '' : destinationData?.countryEntity.stateCountryName}}
                        </div>
                     </div>
                  </div>
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="destinationStateZipCode" class="noMarginLeft">
                           State/Zip
                        </label>
                        <div id="destinationStateZipCode">
                           {{destinationData?.stateId == null ? '' : destinationData?.stateEntity.stateCountryName}},{{destinationData?.zipCode}}
                        </div>
                     </div>
                     <div class="col-md-3">
                        <label for="destinationPrimaryPhone" class="noMarginLeft">
                           Phone
                        </label>
                        <div id="destinationPrimaryPhone">{{destinationData?.phone}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="destinationExtn" class="noMarginLeft">
                           Ext
                        </label>
                        <div id="destinationExtn">{{destinationData?.phoneExt}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="destinationPhone" class="noMarginLeft">
                           Alternate Phone
                        </label>
                        <div id="destinationPhone">{{destinationData?.alternatePhone}}</div>
                     </div>
                  </div>
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="destinationEmail" class="noMarginLeft">
                           Email
                        </label>
                        <div id="destinationEmail">{{destinationData?.emailAddress}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="destinationOtherInfo" class="noMarginLeft">
                           Other Contact Information
                        </label>
                        <div id="destinationOtherInfo">{{destinationData?.otherContactInfo}}
                        </div>
                     </div>
                  </div>
               </div>
               <div class="py-3">
                  <h6 class="p-3 mb-2 bol-addresses-headerBackground text-dark">Consignee Address</h6>
               </div>
               <div id="shiperInfo" class="px-3">
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="consigneeLine1" class="noMarginLeft">
                           Line 1
                        </label>
                        <div id="consigneeLine1">{{consigneeData?.addressLine1}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="consigneeLine2" class="noMarginLeft">
                           Line 2
                        </label>
                        <div id="consigneeLine2">{{consigneeData?.addressLine2}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="consigneeCity" class="noMarginLeft">
                           City
                        </label>
                        <div id="consigneeCity">{{consigneeData?.city}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="consigneeCountry" class="noMarginLeft">
                           Country
                        </label>
                        <div id="consigneeCountry">
                           {{consigneeData?.countryId == null ? '' : consigneeData?.countryEntity.stateCountryName}}
                        </div>
                     </div>
                  </div>
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="consigneeStateZipCode" class="noMarginLeft">
                           State/Zip
                        </label>
                        <div id="consigneeStateZipCode">
                           {{consigneeData?.stateId == null ? '' : consigneeData?.stateEntity.stateCountryName}},{{consigneeData?.zipCode}}
                        </div>
                     </div>
                     <div class="col-md-3">
                        <label for="consigneePhone" class="noMarginLeft">
                           Phone
                        </label>
                        <div id="consigneePhone">{{consigneeData?.phone}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="consigneeExtn" class="noMarginLeft">
                           Ext
                        </label>
                        <div id="consigneeExtn">{{consigneeData?.phoneExt}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="consigneeEmail" class="noMarginLeft">
                           Email
                        </label>
                        <div id="consigneeEmail">{{consigneeData?.emailAddress}}</div>
                     </div>
                  </div>
               </div>
               <div class="py-3">
                  <h6 class="p-3 mb-2 bol-addresses-headerBackground text-dark">Issuing Office Address</h6>
               </div>
               <div id="issuingOfficeInfo" class="px-3">
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="issuingOfficeName" class="noMarginLeft">
                           Office Name
                        </label>
                        <div id="issuingOfficeName">{{issuingOfficer?.issuingOfficeName}}
                        </div>
                     </div>
                     <div class="col-md-3">
                        <label for="issuingOfficePhone" class="noMarginLeft">
                           Phone
                        </label>
                        <div id="issuingOfficePhone">{{issuingOfficer?.phone}}</div>
                     </div>
                  </div>
                  <div class="form-row">
                     <div class="col-md-3">
                        <label for="officerTitle" class="noMarginLeft">
                           Office Title
                        </label>
                        <div id="officerTitle">{{issuingOfficer?.issuingOfficerTitle}}
                        </div>
                     </div>
                     <div class="col-md-3">
                        <label for="officerFirstName" class="noMarginLeft">
                           Officer First Name
                        </label>
                        <div id="officerFirstName">{{issuingOfficer?.firstName}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="officerMiddleName" class="noMarginLeft">
                           Middle Initial
                        </label>
                        <div id="officerMiddleName">{{issuingOfficer?.middleInitial}}</div>
                     </div>
                     <div class="col-md-3">
                        <label for="officerLastName" class="noMarginLeft">
                           Officer Last Name
                        </label>
                        <div id="officerLastName">{{issuingOfficer?.lastName}}</div>
                     </div>
                  </div>
               </div>
            </div>
         </tab>
      </tabset>
   </div>
</div>
<div class="modal-footer">
   <button type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
</div>
